<template>
  <div ref="dynamic_head" class="dynamic-detail-one" :class="'hover-visible'">
    <div class="dynamic-detail-title">
      <fps-avatar
        class="user-avatar"
        :src="info.avatarUrl"
        :dressup="info.avatarFrame"
        :level="info.userLevel"
        :style="{ transform: `scale(${info.userLevel > 5 ? 0.8 : 1})` }"
      />
      <div class="text-wrap">
        <div class="nickname">
          <span>{{ info.nickname }}</span>
          <fps-icon
            v-if="info.userUuid == adminUuid"
            type="v-mark"
            class="is-admin"
            size="18"
            color="#FFA24E"
          />
          <div
            v-else
            class="userlevel-tag level-mg"
            :class="`level-${info.userLevel}`"
          ></div>
        </div>
        <span class="create-time">{{ timeToMin(info.createTime) }}</span>
      </div>
    </div>
    <div v-if="dynamicText" class="content-wrap">
      <div v-html="dynamicText" class="text-content" />
    </div>
    <div v-if="info.content.videoContent" class="video-wrap">
      <FpsVideo
        :class="videoWidth"
        :longWidth="
          +info.content.videoContent.width >= +info.content.videoContent.height
        "
        :src="info.content.videoContent.videoUrl"
        position="cover"
        @click.native.stop
      />
    </div>
    <div v-else-if="info.content.imageContent" class="image-wrap">
      <template v-if="info.content.imageContent.imageUrlList.length > 1">
        <div
          v-for="(list, i) in imgGroup"
          :key="'imagelist-' + i"
          class="img-list"
        >
          <fps-scale-img
            v-for="(url, j) in list"
            :key="'img-' + j"
            class="one-img"
            :src="url + '?d=300x300'"
            :imageList="info.content.imageContent.imageUrlList"
            :defaultIndex="i * 3 + j"
            position="center center"
            borderRadius="12px"
            @click.native.stop
          />
        </div>
      </template>
      <template v-else>
        <div
          v-if="originSize"
          class="origin-image"
          :class="originSize"
          :style="{
            backgroundImage: `url(${info.content.imageContent.imageUrlList[0]})`
          }"
          @click.stop="showScaleImage"
        />
        <div v-else class="origin-image">
          <img
            class="origin-img"
            :src="info.content.imageContent.imageUrlList[0]"
            @click.stop="showScaleImage"
          />
        </div>
        <fps-scale-img
          v-show="false"
          ref="origin_image"
          :src="info.content.imageContent.imageUrlList[0]"
          :imageList="info.content.imageContent.imageUrlList"
          @click.native.stop
        />
      </template>
    </div>
    <div v-if="info.content.skillContent" class="skill-wrap">
      <button>
        <!-- <img class="game-logo" :src="info.content.skillContent.skill.gameLogo" > -->
        <span class="skill-name">{{
          info.content.skillContent.skill.gameName
        }}</span>
        <span class="skill-price"
          >{{ info.content.skillContent.skill.salesPrice }}幣/{{
            info.content.skillContent.skill.salesUnit | salesUnitTranslate
          }}</span
        >
      </button>
    </div>
    <div class="dynamic-feel" @click="changeBoutique()">
      <div class="button">
        <fps-icon v-if="!isBoutique" type="like" class="like-icon" :size="18" />
        <fps-icon
          v-else
          type="like2"
          :class="['like-icon', 'is-like']"
          :size="18"
        />
        <span>加入精选</span>
      </div>
      <span class="preferred" v-if="info.playerExcellent">优陪</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import FpsVideo from '@/components/FpsVideo';

export default {
  name: 'RecentDynamicItem',
  components: {
    FpsVideo
  },
  props: {
    boutiqueList: {
      type: Array,
      default: () => []
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isLoading: false,
      showAllComment: false,
      gettingCommentList: false,
      isBoutique: false, // 是否加精
      boutiqueLoading: false // 加精loading
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'adminUuid']),
    imgGroup() {
      const list = [];
      if (this.info.content.imageContent) {
        const { imageUrlList } = this.info.content.imageContent;
        if (imageUrlList.length === 4) {
          list.push(imageUrlList.slice(0, 2));
          list.push(imageUrlList.slice(2, 4));
        } else {
          let start = 0;
          const step = 3;
          while (start + step < imageUrlList.length) {
            list.push(imageUrlList.slice(start, start + step));
            start += step;
          }
          list.push(imageUrlList.slice(start, imageUrlList.length));
        }
      }
      return list;
    },
    originSize() {
      if (
        !this.info.content.imageContent ||
        this.info.content.imageContent.imageUrlList.length !== 1
      )
        return '';
      const image = this.info.content.imageContent.imageUrlList[0];
      const rs = image.match(/\/(\d+)x(\d+)_/);
      if (!rs) return '';
      const sub = rs[1] / rs[2];
      if (sub > 1.166) {
        return 'is-width';
      } else if (sub < 0.875) {
        return 'is-height';
      }
      return '';
    },
    videoWidth() {
      if (!this.info.content.videoContent) return '';
      const { width, height } = this.info.content.videoContent;
      if (!width || !height) return 'square-video';
      const sub = width / height;
      if (sub > 1.166) {
        return 'width-video';
      } else if (sub < 0.875) {
        return 'height-video';
      }
      return 'square-video';
    },
    dynamicText() {
      let text = '';
      let tag = '';
      if (this.info.content.textContent)
        text =
          this.info.content.textContent.text.replace(/\n/g, '<br>') + '&nbsp;';
      if (this.info.tag)
        tag = `<span style="color: #FE7538;font-weight: normal;">#${this.info.tag}</span>`;
      return text + tag;
    },
    id() {
      return this.info && this.info.id ? this.info.id : '';
    },
    isDefaultBoutique() {
      return (
        this.boutiqueList.includes(this.id) ||
        this.boutiqueList.includes(this.id.toString())
      );
    }
  },
  watch: {
    isDefaultBoutique: {
      handler: function(val) {
        this.isBoutique = val;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    changeBoutique() {
      if (!this.boutiqueLoading) {
        if (this.isBoutique) {
          this.cancelBoutique();
        } else {
          this.addBoutique();
        }
      }
    },
    // 加精
    addBoutique() {
      try {
        this.boutiqueLoading = true;
        this.$http.post('/moment/moment/digest', {
          ids: [this.id]
        });
        this.isBoutique = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.boutiqueLoading = false;
      }
    },
    // 取消加精
    cancelBoutique() {
      try {
        this.boutiqueLoading = true;
        this.$http.post('/moment/moment/unDigest', {
          ids: [this.id]
        });
        this.isBoutique = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.boutiqueLoading = false;
      }
    },
    showScaleImage() {
      if (this.$refs.origin_image)
        this.$refs.origin_image.showFullScreenImage = true;
    },
    timeToMin(time) {
      const d = new Date(time);
      const now = Date.now();
      const createTime = d.getTime();
      // 距离现在几分钟
      let sub = Math.floor((now - createTime) / 60 / 1000);
      if (sub < 5) return '剛剛發佈';
      if (sub < 60) return sub + '分鐘前';
      if (sub < 60 * 24) return Math.floor(sub / 60) + '小時前';
      if (sub < 7 * 60 * 24) return Math.floor(sub / 60 / 24) + '天前';
      let month = d.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      let date = d.getDate();
      if (date < 10) {
        date = '0' + date;
      }
      return `${d.getFullYear()}-${month}-${date}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.dynamic-detail-one {
  box-sizing: border-box;
  border-radius: 4px;
  padding: 24px;
  padding-left: 90px;
  position: relative;
  transform: scale(1);
  width: 728px;
}
.dynamic-detail-title {
  margin-bottom: 10px;
  margin-left: -66px;
  @include flex;
  .user-avatar {
    width: 50px;
    height: 50px;
    margin-right: 16px;
    cursor: pointer;
  }
  .text-wrap {
    flex: 1;
    @include flex(center, flex-start, column);
    .nickname {
      @include flex(flex-start);
      height: 22px;
      margin-bottom: 2px;
      span {
        font-weight: 500;
        font-size: 14px;
        color: $color-gray-1;
      }
      .is-admin {
        margin-left: 3px;
      }
      .userlevel-tag {
        margin-left: 8px;
      }
    }
    .create-time {
      font-size: 12px;
      line-height: 16px;
      color: $color-gray-3;
    }
  }
}
.video-wrap,
.image-wrap {
  margin-bottom: 15px;
  .origin-image {
    border-radius: 12px;
    background: no-repeat center center / cover;
    overflow: hidden;
    .origin-img {
      max-width: 400px;
      max-height: 400px;
      border-radius: 12px;
      cursor: zoom-in;
    }
    &.is-width {
      width: 400px;
      height: 300px;
      cursor: zoom-in;
    }
    &.is-height {
      width: 300px;
      height: 400px;
      cursor: zoom-in;
      background-position: center top;
    }
  }
  .width-video {
    width: 400px;
    height: 300px;
    .fps-video-content {
      height: 100%;
    }
  }
  .square-video {
    width: 400px;
    height: 400px;
    .fps-video-content {
      height: 100%;
    }
  }
  .height-video {
    width: 300px;
    height: 400px;
    .fps-video-content {
      width: 100%;
    }
  }
}
.img-list {
  @include flex(flex-start);
  &:not(:first-child) {
    margin-top: 8px;
  }
  .one-img {
    width: 184px;
    height: 184px;
    background: #f9f9f9;
    &:not(:first-child) {
      margin-left: 8px;
    }
  }
}
.content-wrap {
  margin-bottom: 16px;
  @include flex(flex-start);
  .text-content {
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    margin-right: 4px;
    color: $color-gray-1;
  }
}
.skill-wrap {
  margin-bottom: 21px;
  button {
    img {
      width: 16px;
      border-radius: 50%;
      margin-right: 8px;
    }
    padding: 4px 16px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-1;
    @include flex;
    background: $color-yellow;
    border-radius: 40px;
    .skill-name {
      margin-right: 16px;
    }
  }
}
.line {
  width: 100%;
  height: 1px;
  background: $color-split;
  margin-bottom: 16px;
}
.count-wrap {
  @include flex(flex-start);
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  color: $color-gray-3;
  .like-count {
    color: $color-gray-1;
    margin-right: 35px;
  }
}
.dynamic-feel {
  display: flex;
  align-items: center;
  .like-icon {
    display: inline-block;
    color: #636d86;
  }
  .is-like {
    color: #fa006e;
  }
  .click-like {
    animation: zoomfn 0.5s ease-in-out 1;
  }
  .button {
    padding: 10px;
    border: 1px solid #efefef;
    border-radius: 20px;
    cursor: pointer;
  }
  .preferred {
    padding: 4px 8px;
    margin-left: 10px;
    border-radius: 20px;
    background: #fa006e;
    color: white;
  }
}
@media screen and (max-width: 599px) {
  .dynamic-detail-one .image-wrap .origin-image {
    .origin-img {
      max-width: 200px;
      max-height: 200px;
    }
    &.is-width,
    &.is-height {
      max-width: 200px;
      max-height: 200px;
    }
  }
  .dynamic-detail-one .img-list .one-img {
    width: 60px;
    height: 60px;
  }
}
</style>
